module.exports = __webpack_public_path__ + "static/media/novo-logo.5b055658.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/img/forside/novo-logo.jpg
// module id = 1474
// module chunks = 0